export const useSxStyles = () => {
  return {
    text: {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      marginTop: 'auto',
      marginBottom: 'auto',
      '& > *': {
        display: 'inline',
      },
    },
  };
};
